// extracted by mini-css-extract-plugin
export default {"veraButton":"veraBtn_veraButton__PvBg3","right":"veraBtn_right__U88K8","danger":"veraBtn_danger__JPLyY"};